import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Typography, Avatar } from '@material-ui/core';

const BRAND_COLOR = '#682622';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: BRAND_COLOR,
    boxShadow: '0 1px 0 rgba(0,0,0,0.12)',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
  },
  toolbar: {
    minHeight: 56,
    [theme.breakpoints.up('sm')]: {
      minHeight: 64,
    },
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    textDecoration: 'none',
    color: 'inherit',
  },
  avatar: {
    width: 32,
    height: 32,
    border: '1.5px solid rgba(255,255,255,0.5)',
  },
  brandName: {
    fontWeight: 700,
    fontSize: '1rem',
    letterSpacing: '0.5px',
    color: '#ffffff',
  },
  divider: {
    width: 1,
    height: 20,
    backgroundColor: 'rgba(255,255,255,0.25)',
    margin: theme.spacing(0, 1.5),
  },
  tagline: {
    fontSize: '0.75rem',
    color: 'rgba(255,255,255,0.65)',
    letterSpacing: '0.3px',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
}));

const Topbar = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      position="fixed"
    >
      <Toolbar className={classes.toolbar}>
        <RouterLink className={classes.brand} to="/">
          <Avatar
            alt="AADGG"
            className={classes.avatar}
            src="/images/adgg_avatar.png"
          />
          <Typography className={classes.brandName}>TDGG WEB</Typography>
          <span className={classes.divider} />
          <Typography className={classes.tagline}>
            More Productive &amp; Profitable Dairy Cows
          </Typography>
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string
};

export default Topbar;
